<div class="modal" bsModal #modalComponent="bs-modal" tabindex="-1" role="dialog">
  <div class="modal-dialog"  [class.modal-lg]="!config.small" [class.modal-sm]="config.small">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title pull-left">{{title}}</h4>
        <img *ngIf="config.resizeOrClose==='resize'" src="images/resize.png" alt="[resize]" class="pull-right" style="cursor: pointer;" (click)="resize()"/>
        <img *ngIf="config.resizeOrClose==='close'" src="images/close.png" alt="[close]" class="pull-right" style="cursor: pointer;" (click)="close()"/>
      </div>
      <mat-spinner *ngIf="config.showSpinner" [ngClass]="config.spinnerCssClass" [color]="config.spinnerColorTheme"></mat-spinner>
      <div id="source-content" class="modal-body" >
        <ng-content></ng-content>
      </div>
      <div>
        <span *ngIf="config.reprocessable">
            <mat-icon data-toggle="tooltip" data-placement="bottom" title="Click To Reprocess Submission" class="icon reprocess" (click)="confirmReprocess()">refresh</mat-icon>
        </span>
        <div class="modal-footer">
          <span class="footer-message pull-left">{{config.footerMessage}}</span>
          <button *ngIf="config.cancelBtnTitle!==''" type="button" [ngClass]="config.cancelBtnCssClass"  (click)="reject()" [innerHTML]="config.cancelBtnTitle"></button>
          <button *ngIf="config.editBtnTitle!==''" type="button" [ngClass]="config.okBtnCssClass"  (click)="edit()" [innerHTML]="config.editBtnTitle"></button>
          <button *ngIf="config.okBtnTitle!==''" type="button" [ngClass]="config.okBtnCssClass"  (click)="accept()" [innerHTML]="config.okBtnTitle"></button>
          <button *ngIf="config.resubmitBtnTitle!==''" type="button" [ngClass]="config.okBtnCssClass"  (click)="resubmit()" [innerHTML]="config.resubmitBtnTitle"></button>
          <button *ngIf="config.reprocessBtnTitle!==''" type="button" [ngClass]="config.okBtnCssClass"  (click)="reprocess()" [innerHTML]="config.reprocessBtnTitle"></button>
        </div>
      </div>
    </div>
  </div>
</div>
